import { useAppConfig } from "@/appConfig";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";

// Gitcha shows PRO for any agent; the premium check only applies to MLS tenants.
const ProBadge = ({ isAgentPremium = false, className = "pro-tag" }) => {
  const { flags } = useAppConfig();
  const { isGitchaDefaultWebsite } = useCurrentWebsite();

  if (!flags.proBadge) return null;
  if (!isGitchaDefaultWebsite && !isAgentPremium) return null;

  return <span className={className}>PRO</span>;
};

export default ProBadge;
